module.exports = __webpack_public_path__ + "img/icon-active.b00510bb.svg";